import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const CREATE_DEPOSIT_TRANSFER = gql`
  mutation createDepositTransfer($input: CreateDepositTransferInput!) {
    createDepositTransfer(input: $input) {
      transfer {
        id
        state
      }
    }
  }
`;

export const CREATE_SCHEDULED_DEPOSIT_TRANSFER = gql`
  mutation createScheduledDepositTransfer(
    $input: CreateScheduledDepositTransferInput!
  ) {
    createScheduledDepositTransfer(input: $input) {
      scheduledTransfer {
        id
        state
      }
    }
  }
`;

export const TRANSFER_BETWEEN_SUB_ACCOUNTS = gql`
  mutation transferBetweenSubAccounts(
    $input: TransferBetweenSubAccountsInput!
  ) {
    transferBetweenSubAccounts(input: $input) {
      transfer {
        id
        state
      }
    }
  }
`;

export const TRANSFER_ALL_BETWEEN_SUB_ACCOUNTS = gql`
  mutation transferAllBetweenSubAccounts(
    $input: TransferAllBetweenSubAccountsInput!
  ) {
    transferAllBetweenSubAccounts(input: $input) {
      transfer {
        id
        state
      }
    }
  }
`;

export const CREATE_EXTERNAL_TRANSFER = gql`
  mutation createExternalTransfer($input: CreateExternalTransferInput!) {
    createExternalTransfer(input: $input) {
      manualProcess {
        id
        subAccount {
          id
          account {
            id
          }
          transfers {
            id
            manualProcess {
              id
            }
          }
        }
      }
    }
  }
`;

export const CREATE_CUSTODIAN_TRANSFER = gql`
  mutation createCustodianDepositTransfer(
    $input: CreateCustodianDepositTransferInput!
  ) {
    createCustodianDepositTransfer(input: $input) {
      confirmationNumber
      status
      action {
        type
        details {
          key
          value
        }
      }
    }
  }
`;

export const FETCH_SUBACCOUNT_DETAILS = gql`
  query FetchSubAccountDetails($subAccountId: ObjectID!) {
    fetchSubAccount(subAccountId: $subAccountId) {
      subAccount {
        id
        name
        account {
          id
          type
          custodianAccountNumber
          custodianAccountName
          nickName
          translatedNickName { ${TRANSLATED_STRING_FIELDS} }
          user {
            id
            firstName
            lastName
          }
        }
        goal {
          id
          type
          name
        }
        financialProduct {
          id
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
        statistics {
          marketValueCents
        }
      }
    }
  }
`;

export const UPDATE_SCHEDULED_TRANSFER = gql`
  mutation updateScheduledTransfer($input: UpdateScheduledTransferInput!) {
    updateScheduledTransfer(input: $input) {
      scheduledTransfer {
        id
      }
    }
  }
`;
